// extracted by mini-css-extract-plugin
export default {"file":"File_file_dRyuo","readonly":"File_readonly_PYsny"};